/**
 * Maintained by Sandon.
 */
<template>
<!--  :init-options="initOptions"-->
  <sy-select
    ref="select"
    class="sy-filter-select"
    v-model="selected"
    :filterable="filterable"
    :remote="remote"
    :remote-method="remote ? remoteFilter : undefined"
    :loading="state.loading"
    :clearable="clearable"
    :size="size"
    :multiple="multiple"
    :fix-height="fixHeight"
    :placeholder="placeholder"
    :filter-placeholder="filterPlaceholder"
    :must-have-query="mustHaveQuery"
    :disabled="disabled"
    :visible.sync="visible"
    :options="innerOptions"
    :popperWidth="popperWidth"
    :popper-height="popperHeight"
    :multiple-limit="multipleLimit"
    :loadingText="loadingText"
    :noDataText="noDataText"
    :clearFilter="clearFilter"
    :useEmptySlot="useEmptySlot"
    :frozen="frozen"
    @change="selectChange"
    @visible-change="visibleChange"
    @clear="$emit('clear')">
<!--    <sy-option-->
<!--      v-for="item in state.options"-->
<!--      :key="item[state.keys.optionsValueKey] + item[state.keys.optionsLabelKey]"-->
<!--      :label="item[state.keys.optionsLabelKey]"-->
<!--      :value="item[state.keys.optionsValueKey]">-->
<!--    </sy-option>-->
    <template slot="footer" slot-scope="scope">
      <slot name="footer"></slot>
    </template>
    <template slot="empty" slot-scope="scope">
      <slot name="empty"></slot>
    </template>
  </sy-select>
</template>

<script>
  import i18n from './i18n.js'
  import response from '../../../utils/response'
  // import {addClass, removeClass} from '../../../utils/dom'
  import SySelect from '../select'
  import SyOption from '../option'
  import {arrayContentSame} from "../../../utils";
  const pageText = window.fe.getPageText(i18n)
  export default {
    name: 'filter-select',
    props: {
      model: {type: Object || Array, default: () => { return {} }, required: true},
      keys: {type: Object, default: null, required: true},
      api: {type: Object, default: null},
      filterable: {type: Boolean, default: true},
      remote: {type: Boolean, default: true},
      getParams: {type: Function, default: null},
      mustHaveQuery: {type: Boolean, default: false},
      size: {type: String, default: 'small'},
      multiple: {type: Boolean, default: false},
      // 是否固定高度
      fixHeight: {type: Boolean, default: true},
      placeholder: {type: String, default: pageText.pleaseEnter},
      // 过滤搜索时，输入框的placeholder
      filterPlaceholder: {type: String, default: pageText.search},
      options: {type: Array, default: () => []},
      disabled: {type: Boolean, default: false},
      // 下拉是否展示
      visible: {type: Boolean, default: false},
      // 是否可清空（只对单选）
      clearable: {type: Boolean, default: true},
      // label 为空时的替换字符
      replacement: {type: String, default: '-'},
      // 对请求的结果进行格式化的函数，场景：返回的不是一个list的数据
      formatFn: {type: Function | null, default: null},
      // popper宽度
      popperWidth: {type: Number, default: 0},
      // dropdown height
      popperHeight: {type: Number, default: 280},
      // 多选时选中条目数限制,为 0 则不限制
      multipleLimit: {type: Number, default: 0},
      // 加载中时的提示文案, undefined 以使用底层默认值
      loadingText: {type: String, default: undefined},
      // 无数据时的提示文案, undefined 以使用底层默认值
      noDataText: {type: String, default: undefined},
      // 多选时点选option之后是否自动清除搜索词
      clearFilter: {type: Boolean, default: false},
      // 是否冻结，冻结时不会监听滚动事件而调整 popper 位置, popper 展开状态也将保持不变
      frozen: {type: Boolean, default: false}
    },
    components: {SySelect, SyOption},
    data () {
      return {
        selected: null, // 单个值（单选），或值数组（多选）
        selectedOptions: [], // 多选时用到，选中的项的options
        state: {
          loading: false,
          options: this.options,
          keys: {
            valueKey: '',
            labelKey: '',
            optionsValueKey: '',
            optionsLabelKey: ''
          }
        },
        firstFetched: false,
        // optionsBackup: null,
        // initOptions: []
        
        useEmptySlot: false
      }
    },
    computed: {
      // todo 待select组件支持自定义的labelKey 和 valueKey 后可以优化掉，尽量减少数组的copy/map，以优化性能
      innerOptions: function () {
        const {optionsLabelKey, optionsValueKey} = this.state.keys
        return this.state.options.map(_ => ({
          label: _[optionsLabelKey],
          value: _[optionsValueKey]
        }))
      }
    },
    watch: {
      options: function () {
        this.state.options = this.options
      }
    },
    created () {
      // 外部传入的options具有最高优先级，此时不会继续远程搜索
      if (this.options.length) {
        this.remote = false
      }
      
      // 复制过来以避免不必要的响应式，因为业务代码中一般会在模板中直接定义keys对象
      if (this.keys) {
        Object.assign(this.state.keys, this.keys)
      }
      
      // 构造 realLabelCombineFn
      if (this.state.keys.optionsLabelCombined) {
        const {labelSeparator, labelCombineFn} = this.state.keys
        this.realLabelCombineFn = labelCombineFn || ((partLabels) => {
          // default labelCombineFn
          return partLabels.reduce((combinedLabel, partLabel, index) => {
            return combinedLabel += combinedLabel ? labelSeparator + partLabel : partLabel
          }, '')
        })
      }

      // 初始化
      this.initSelect()

      // 建立 watch
      const vm = this
      if (!this.multiple) { // 单选时，监听model以初始化
        this.$watch(`model.${this.state.keys.valueKey}`, function (newVal, oldVal) {
          const {valueKey} = this.state.keys
          if ( this.selected !== this.model[valueKey]) {
            vm.initSelect()
          }
        })
      } else {
        this.$watch(`model`, function (newVal, oldVal) {
          const {valueKey} = this.state.keys
          const modelValues = this.model.map(_ => _[valueKey])
          if (!arrayContentSame(this.selected, modelValues)) {
            vm.initSelect()
          }
        })
      }
    },
    mounted () {
      this.useEmptySlot = !!this.$scopedSlots.empty
    },
    methods: {
      // 初始化：selected值(select组件的model) 、 options
      initSelect () {
        if (this.multiple) {
          // 多选
          if (!Array.isArray(this.model)) return
          
          this.selected = this.model.map(item => item[this.state.keys.valueKey])
          
          if (!this.options.length) {
            this.initSelectOptionsMultiple()  
          }
        } else {
          // 单选
          this.selected = this.model[this.state.keys.valueKey]
          
          if (!this.options.length) {
            this.initSelectOptionsSingle()  
          }
        }
      },
      // 初始化下拉项 - 单选
      initSelectOptionsSingle () {
        const {valueKey, labelKey, labelCombined, optionsLabelKey, optionsValueKey} = this.state.keys

        if (!this.model || !this.notEmpty(this.model[valueKey])) return

        if (labelCombined) {
          // 组合的label
          // let label = ''
          // labelCombined.forEach(key => {
          //   const partLabel = this.model[key] || this.replacement
          //   label += label ? labelSeparator + partLabel : partLabel
          // })
          const label = this.realLabelCombineFn(labelCombined.map(key => this.model[key] || this.replacement))
          
          // this.initOptions = [{
          //   label,
          //   value: this.model[valueKey]
          // }]
          this.state.options = [{
            [optionsLabelKey]: label,
            [optionsValueKey]: this.model[valueKey]
          }]
        } else if (this.notEmpty(this.model[labelKey])) {
          // 非组合的label
          // this.initOptions = [{
          //   label: this.model[labelKey] || this.replacement,
          //   value: this.model[valueKey]
          // }]
          this.state.options = [{
            [optionsLabelKey]: this.model[labelKey] || this.replacement,
            [optionsValueKey]: this.model[valueKey]
          }]
        }
      },
      // 初始化下拉项 - 多选
      initSelectOptionsMultiple () {
        const options = this.model.map(item => this.getOption(item))
        this.selectedOptions = [...options]

        // 转换成 initOptions 需要的格式
        // const {optionsValueKey, optionsLabelKey} = this.state.keys
        // this.initOptions = options.map(option => {
        //   return {
        //     label: option[optionsLabelKey],
        //     value: option[optionsValueKey]
        //   }
        // })
        
        this.state.options = options
      },
      // 初始化时，根据 model 得到 option
      getOption (itemModel) {
        const {valueKey, labelKey, optionsValueKey, optionsLabelKey, labelCombined, optionsLabelCombined} =
          this.state.keys
        if (labelCombined) {
          // 组合的label
          const option = {
            [optionsValueKey]: itemModel[valueKey]
          }
          const partLabels = []
          labelCombined.forEach((key, index) => {
            const partLabel = itemModel[key] || this.replacement
            // label += label ? labelSeparator + partLabel : partLabel
            option[optionsLabelCombined[index]] = partLabel
            partLabels.push(partLabel)
          })
          option[optionsLabelKey] = this.realLabelCombineFn(partLabels) // 展示用
          return option
        } else {
          // 非组合的label
          return {
            [optionsLabelKey]: itemModel[labelKey] || this.replacement,
            [optionsValueKey]: itemModel[valueKey]
          }
        }
      },
      // 空判断
      notEmpty (data) {
        return data !== null && data !== undefined && data !== ''
      },
      // 下拉框点选
      selectChange (val) {
        const {valueKey, labelKey, optionsValueKey, optionsLabelKey, labelCombined, optionsLabelCombined} =
          this.state.keys
        if (this.multiple) {
          // 多选

          // 找出选中options selectedOptions
          const optionMap = {} // value => option
          this.selectedOptions.forEach(option => (optionMap[option[optionsValueKey]] = option))
          this.state.options.forEach(option => (optionMap[option[optionsValueKey]] = option)) // 用远端加载的options覆盖初始化时的options
          const selectedOptions = val.map(value => optionMap[value]) // 只会选出被选中的所有options
          this.selectedOptions = selectedOptions

          // 修改model
          this.model.splice(0, this.model.length)
          selectedOptions.forEach(option => {
            const item = {
              [valueKey]: option[optionsValueKey]
              // [labelKey]: option[optionsLabelKey]
            }
            if (labelCombined) {
              labelCombined.forEach((key, index) => {
                item[key] = option[optionsLabelCombined[index]]
              })
            } 
            // else {
            //   item[labelKey] = option[optionsLabelKey]
            // }
            item[labelKey] = option[optionsLabelKey]
            this.model.push(item)
          })

          // 通知
          this.$emit('change', val, selectedOptions)
          // todo deprecated
          this.$emit('change-with-extra', {
            value: val,
            options: selectedOptions
          })
        } else {
          // 单选

          // 修改 value
          // this.model[valueKey] = val
          this.$set(this.model, valueKey, val)

          // 修改 label
          const option = this.state.options.find(option => option[optionsValueKey] === val)
          if (option) {
            if (labelCombined) {
              labelCombined.forEach((key, index) => {
                this.$set(this.model, key, option[optionsLabelCombined[index]])
              })
            } 
            // else {
            //   this.$set(this.model, labelKey, option[optionsLabelKey])
            // }
            this.$set(this.model, labelKey, option[optionsLabelKey])
          } else {
            // 没找到对应的option, 因此label清空
            this.$set(this.model, labelKey, '')
          }

          // 通知
          this.$emit('change', val, option)
          // todo deprecated
          this.$emit('change-with-extra', {
            value: val,
            option
          })
        }
      },
      // 下拉筛选过滤
      async remoteFilter (query = '') {
        if (!this.api) return // 业务上可能以为着用户自己传options
        if (!this.remote && this.firstFetched) return // 非远程过滤，也既只需focus请求一次，而已经请求过了
        if (this.mustHaveQuery && !query) {
          this.state.options = []
          // this.initSelect()
          return
        }
        const api = this.api
        const param = this.getParams ? this.getParams.call(null, query) : {name: query}
        // 配合 getParams 返回false的场景
        if (!param) {
          // 未请求清空下拉选项
          this.state.options = []
          return
        }
        this.state.loading = true
        const res = await response(this.$http(api.type, api.url, param), {
          loadingOptions: false
        })
        if (res.isOk) {
          const content = (this.formatFn ? this.formatFn(res.content) : res.content) || []

          // label 的处理
          const {optionsLabelKey, optionsLabelCombined} = this.state.keys
          if (optionsLabelCombined) {
            content.forEach((item) => {
              // let label = ''
              // optionsLabelCombined.forEach(key => {
              //   const partLabel = item[key] || this.replacement
              //   label += label ? labelSeparator + partLabel : partLabel
              // })
              // item[optionsLabelKey] = label
  
              item[optionsLabelKey] = this.realLabelCombineFn(
                optionsLabelCombined.map(key => item[key] || this.replacement)
              )
            })
          } else {
            content.forEach((item) => {
              item[optionsLabelKey] = item[optionsLabelKey] || this.replacement
            })
          }

          this.state.options = content
          this.firstFetched = true
        }
        this.state.loading = false
      },
      visibleChange (visible) {
        this.$emit('visible-change', visible)
        this.$emit('update:visible', visible)

        // todo 等待select组件如移动端优化
        if (visible) {
          this.remoteFilter()
        }
      },
      // 对外接口 - 多选时初始化
      init () {
        this.initSelect()
      },
      // // 对外接口 - 展开下拉
      // async open () {
      //   await this.$refs['select']?.open()
      // },
      // // 对外接口 - 收起下拉
      // close () {
      //   this.$refs['select']?.close()
      // },
      // // 对外接口 - 下拉状态冻住，即保持当前下拉状态不再改变直到解冻
      // freeze () {
      //   this.$refs['select']?.freeze()
      // },
      // // 对外接口 - 下拉状态解冻
      // unfreeze () {
      //   this.$refs['select']?.unfreeze()
      // }
    }
  }
</script>

<style scoped>

</style>
